export default function buildCalendar(value) {
	const startDay = value.clone().startOf('month').startOf('week')
	const endDay = value.clone().endOf('month').endOf('week')

	const day = startDay.clone().subtract(1, 'day') // iterator day to loop and construct calendar

	// while until day is before endDay
	const calendar = []
	while (day.isBefore(endDay, 'day')) {
		calendar.push(
			Array(7)
				.fill(0)
				.map(() => day.add(1, 'day').clone())
		)
	}

	return calendar
}
